import { FC, PropsWithChildren } from "react";

export const MenuSection: FC<PropsWithChildren> = ({ children }) => {
  return <div className="py-1.5">{children}</div>;
};
